export const INNER_ELEMENT_TAG = 'wix-ie'
export const INNER_ELEMENT_TYPE = 'InnerElement'
